import { Component, OnInit, Inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileDocument } from '../models/file-document.model';
import { FileDocumentService } from '../services/file-document.service';
import { MessageService } from 'src/app/modules/shared/errorHandler/message.service';
import { FileService } from '../services/file.service';
import { documentFileSignaturesData } from '../models/documentFileSignatures.model';
import { firstValueFrom } from 'rxjs';

/** Datos del modal. filePdf viene cargado cuando la evidencia se obtuvo con getmydocumentandpdf (módulo de empleado). */
export type ProveDocumentViewData = FileDocument & { filePdf?: string | null };

@Component({
  standalone: false,
  selector: 'app-file-prove-document-view-modal',
  templateUrl: './file-prove-document-view-modal.component.html',
  styleUrls: ['_fileProveDocumentModal.scss']
})
export class FileProveDocumentViewModalComponent implements OnInit {
  doc: FileDocument;
  filePdf = "";
  fileName = "";
  fileBlob: Blob;
  items=  [];
  employeeId="0";


  constructor(@Inject(MAT_DIALOG_DATA) public data: ProveDocumentViewData,
    private fileDocumentService: FileDocumentService,  
    private msjService: MessageService,
    private _bottomSheet: MatBottomSheet,
    private fileService: FileService,
    private dialogRef: MatDialogRef<FileProveDocumentViewModalComponent>) {
    
    this.doc = this.data; 
    this.items=this.data.documentFileSignaturesData;
    
    this.setSignedBy(this.data.collaboration,this.items);
    
  }

  ngOnInit() {
    if (this.data.filePdf) {
      this.filePdf = this.data.filePdf;
      this.fileName = this.fileDocumentService.getDocumentFileName(this.doc);
      this.msjService.close();
      return;
    }

    firstValueFrom(this.fileService.getDocumentFilePdfByIdBase64(this.doc.id, this.employeeId)).then(
      file => {
        this.filePdf = file?.base64 ?? file;
        this.fileName = this.fileDocumentService.getDocumentFileName(this.doc);
        this.msjService.close();
      },
      err => this.msjService.showError(err)
    );
  }


  onOpenDocument(sign:documentFileSignaturesData){
    
    this.doc.id=sign.proveDocumentId;
    this.doc.documentDate = new Date(sign.signedDate);
    firstValueFrom(this.fileService.getDocumentFilePdfByIdBase64(sign.proveDocumentId, this.employeeId)).then(
      file => {
        this.filePdf = file?.base64 ?? file;
        this.fileName = this.fileDocumentService.getDocumentFileName(this.doc);
        this.msjService.close();
        
      },
      err => this.msjService.showError(err)
    );
  }

  dialogClose() {
    this._bottomSheet.dismiss();
    this.dialogRef.close();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setSignedBy(collaborations: any,items: documentFileSignaturesData[])
  {
      items.forEach(i => {        
       if(collaborations.find(col => col.userId===i.userId)==undefined)
       {
          i.signedBy="Firmante"
       }   
       else
       {
        i.signedBy="Empleado"
       }     
      });
  }
  
}
